import { BookingStatus } from './booking-status';

/**
 * The guest-registration (MIR) states both apps gate the guest flow on, mirroring back-host-bo
 * `BookingWorkflow.Mir`. The back office and the guest site read the same workflow, so they share
 * these sets instead of keeping their own copies.
 */

/** Hospedajes holds the current data, in flight or accepted: an unchanged repeat send is ignored. */
export const MIR_DATA_HELD_STATES: ReadonlySet<string> = new Set([
  'BOOKING_NOTIFICATION_PENDING',
  'CHECKIN_PENDING',
  'CHECKIN_NOTIFICATION_PENDING',
  'MIR_COMPLETED',
]);

/** Hospedajes accepted the booking notification (the check-in may still be due). */
export const MIR_ACCEPTED_STATES: ReadonlySet<string> = new Set([
  'CHECKIN_PENDING',
  'CHECKIN_NOTIFICATION_PENDING',
  'MIR_COMPLETED',
]);

/** Hospedajes refused a send: the backend takes a corrected one. */
export const MIR_CORRECTION_STATES: ReadonlySet<string> = new Set([
  'BOOKING_NOTIFICATION_ERROR',
  'CHECKIN_ERROR',
]);

/** The data waits for whoever authorizes the send: missing, or complete and not sent yet. */
export const MIR_AWAITING_SEND_STATES: ReadonlySet<string> = new Set([
  'GUEST_MIR_DATA_PENDING',
  'SEND_GUEST_MIR_DATA_PENDING',
]);

/** Booking statuses only the three-machine workflow writes, never a legacy single-machine code. */
const CANONICAL_ONLY_STATUSES: ReadonlySet<string> = new Set([
  BookingStatus.CHECKIN_SCHEDULED,
  BookingStatus.CANCELLED_BY_GUEST,
  BookingStatus.CANCELLED_BY_HOST,
  BookingStatus.CANCELLED_BY_CHANNEL,
]);

/**
 * True for a status only the three-machine workflow writes. A read carrying one always comes with
 * `paymentState`, `mirState` and `manualMirManaged`; when they are missing the backend is stale and
 * the machines are unknown, never inferred from the status.
 */
export function isCanonicalOnlyBookingStatus(status: string | null | undefined): boolean {
  return CANONICAL_ONLY_STATUSES.has((status ?? '').trim().toUpperCase());
}
